import { FavoriteActionType } from "src/services/favorites/types";
import { sendAnalyticEvent } from "src/utils/analytics/sendAnalyticEvent";

export const sendChangeButtonClick = (action: FavoriteActionType) => {
  sendAnalyticEvent({
    event: "change_product_lists_button_clicked",
    action: action === 'add' ? "add_to_list" : "remove_from_list",
  });
};
